import { motion, useScroll, useTransform } from "framer-motion";

export const ScrollBackdrop = () => {
  const { scrollYProgress } = useScroll();
  const y1 = useTransform(scrollYProgress, [0, 1], ["0%", "-40%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["0%", "55%"]);
  const y3 = useTransform(scrollYProgress, [0, 1], ["0%", "-70%"]);
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 140]);

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      <motion.div
        style={{ y: y1, rotate }}
        className="absolute -top-40 -right-44 h-[36rem] w-[36rem] rounded-full bg-forest/15 blur-3xl"
      />
      <motion.div
        style={{ y: y2 }}
        className="absolute top-[40%] -left-52 h-[32rem] w-[32rem] rounded-full bg-[#C88F52]/40 blur-3xl"
      />
      <motion.div
        style={{ y: y3 }}
        className="absolute -bottom-40 right-[12%] h-[30rem] w-[30rem] rounded-full bg-ember/15 blur-3xl"
      />
    </div>
  );
};
